import { formatName } from "utils/helperfunctions"
export const texttemplates = (city: any, county: any, ) => {
    return [
    `With number if foreclosures proceedings slowing, ${formatName(city)} is showing signs of housing improvement`,
]
}